import { useState, useEffect, useCallback } from 'react';

var API = 'https://api.algrok.com';

function fmtINR(n) {
  if (n == null || isNaN(n)) return '--';
  var sign = n < 0 ? '−' : '+';
  return sign + '₹' + Math.abs(n).toLocaleString('en-IN', { maximumFractionDigits: 0 });
}
function fmtL(v) {
  if (v == null || isNaN(v)) return '--';
  var a = Math.abs(v);
  var s = a >= 1e7 ? (v / 1e7).toFixed(2) + 'Cr' : a >= 1e5 ? (v / 1e5).toFixed(1) + 'L' : String(Math.round(v));
  return (v > 0 ? '+' : '') + s;
}

function StatBox(props) {
  return (
    <div style={{ flex: 1, minWidth: 92, background: '#0a0f1c', border: '1px solid #1f2937', borderRadius: 10, padding: '8px 12px', textAlign: 'center' }}>
      <div style={{ fontSize: 9, fontWeight: 800, letterSpacing: 0.8, color: '#556677' }}>{props.label}</div>
      <div style={{ fontSize: 18, fontWeight: 800, color: props.color || '#e5e7eb', marginTop: 2 }}>{props.value}</div>
    </div>
  );
}

var FIELD_LBL = { fontSize: 12, color: '#8b98a9', marginBottom: 5 };
var FIELD_IN = { width: '100%', boxSizing: 'border-box', background: '#0d1524', border: '1px solid #26334a', borderRadius: 8, color: '#e5e7eb', fontSize: 14, padding: '9px 12px', fontFamily: 'inherit' };

function Field(props) {
  return (
    <div>
      <div style={FIELD_LBL}>{props.label}{props.hint ? <span style={{ color: '#ef4444', fontSize: 10 }}> {props.hint}</span> : null}</div>
      {props.options ? (
        <select value={props.value} onChange={function (e) { props.onChange(e.target.value); }} style={FIELD_IN}>
          {props.options.map(function (o) { return <option key={o[0]} value={o[0]}>{o[1]}</option>; })}
        </select>
      ) : (
        <input type={props.type || 'text'} value={props.value} onChange={function (e) { props.onChange(e.target.value); }} style={FIELD_IN} />
      )}
    </div>
  );
}

var OIRideR = function () {
  var [state, setState] = useState(null);
  var [showCfg, setShowCfg] = useState(false);
  var [draft, setDraft] = useState({});
  var [err, setErr] = useState('');
  var [sibPnl, setSibPnl] = useState(null);

  var fetchState = useCallback(function () {
    fetch(API + '/oirider/state').then(function (r) { return r.json(); }).then(function (d) {
      if (d && !d.error) { setState(d); setErr(''); } else setErr((d && d.error) || 'unavailable');
    }).catch(function () { setErr('backend unreachable'); });
  }, []);

  useEffect(function () {
    fetchState();
    var id = setInterval(fetchState, 1000);
    function fetchSib() {
      fetch(API + '/oiride/state').then(function (r) { return r.json(); }).then(function (d) {
        if (d && d.stats) setSibPnl(d.stats.day_pnl);
      }).catch(function () {});
    }
    fetchSib();
    var sid = setInterval(fetchSib, 5000);
    function wake() { if (!document.hidden) fetchState(); }
    document.addEventListener('visibilitychange', wake);
    return function () { clearInterval(id); clearInterval(sid); document.removeEventListener('visibilitychange', wake); };
  }, [fetchState]);

  var cfg = (state && state.config) || {};
  var enabled = cfg.enabled !== false;

  function postCfg(payload, close) {
    fetch(API + '/oirider/config', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) })
      .then(function () { if (close) { setShowCfg(false); } setTimeout(fetchState, 400); }).catch(function () {});
  }
  function openCfg() {
    setDraft({
      entry_time: cfg.entry_time || '09:17', exit_time: cfg.exit_time || '15:00',
      paper_lots: cfg.paper_lots != null ? cfg.paper_lots : 1,
      check_interval_sec: cfg.check_interval_sec != null ? cfg.check_interval_sec : 30,
      threshold_pct: cfg.threshold_pct != null ? cfg.threshold_pct : 10,
      confirm_checks: cfg.confirm_checks != null ? cfg.confirm_checks : 1,
      strikes_band: cfg.strikes_band != null ? cfg.strikes_band : 20,
      spread_haircut_pct: cfg.spread_haircut_pct != null ? cfg.spread_haircut_pct : 0.25,
      next_week_days: Object.assign(
        { monday: false, tuesday: false, wednesday: false, thursday: false, friday: false },
        (cfg.next_week_days && typeof cfg.next_week_days === 'object') ? cfg.next_week_days : {}),
      hedge_offset_normal: cfg.hedge_offset_normal != null ? cfg.hedge_offset_normal : 2,
      hedge_offset_expiry: cfg.hedge_offset_expiry != null ? cfg.hedge_offset_expiry : 1,
      mtm_sl_per_lot: cfg.mtm_sl_per_lot || 0, target_per_lot: cfg.target_per_lot || 0,
      protect_per_lot: cfg.protect_per_lot || 0, protect_level_per_lot: cfg.protect_level_per_lot || 0,
      trail_step_per_lot: cfg.trail_step_per_lot || 0,
    });
    setShowCfg(true);
  }
  function saveCfg() {
    var p = {};
    Object.keys(draft).forEach(function (k) {
      var v = draft[k];
      // next_week_days is an OBJECT — Number() would make it NaN and wipe the
      // schedule, the same way it wiped `weekdays` on the Walls pages.
      if (k === 'next_week_days') { p[k] = v; return; }
      p[k] = (k === 'entry_time' || k === 'exit_time') ? v : Number(v);
    });
    postCfg(p, true);
  }
  function D(k) { return function (v) { var d = Object.assign({}, draft); d[k] = v; setDraft(d); }; }

  var sig = (state && state.signal) || {};
  var pend = (state && state.pending) || {};
  var pos = state && state.position;
  var st = (state && state.stats) || {};
  var trades = (state && state.trades) || [];
  var events = (state && state.events) || [];
  var isShort = function (l) { return l.act === 'S' || l.kind === 'sell' || l.kind === 'wing'; };
  var sellPnl = 0;
  trades.forEach(function (t) { (t.legs || []).forEach(function (l) { if (isShort(l)) sellPnl += (l.pnl || 0); }); });
  if (pos) (pos.legs || []).forEach(function (l) { if (isShort(l)) sellPnl += (l.pnl || 0); });
  sellPnl = Math.round(sellPnl * 100) / 100;
  var cardBase = { background: '#0a0f1c', border: '1px solid #1f2937', borderRadius: 12, padding: '12px 14px' };
  var vCol = sig.verdict === 'LONG' ? '#22c55e' : sig.verdict === 'SHORT' ? '#ef4444' : '#8b98a9';
  var mx = Math.max(Math.abs(sig.dpe || 0), Math.abs(sig.dce || 0), 1);

  function bar(v, col) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <div style={{ flex: 1, height: 12, background: '#0d1524', borderRadius: 4, overflow: 'hidden' }}>
          <div style={{ width: (Math.abs(v) / mx * 100) + '%', height: '100%', background: col, opacity: 0.85 }} />
        </div>
        <span style={{ fontSize: 11, fontWeight: 800, color: col, minWidth: 62, textAlign: 'right' }}>{fmtL(v)}</span>
      </div>
    );
  }

  return (
    <div style={{ padding: '18px 22px', color: '#e5e7eb', fontFamily: 'inherit', maxWidth: 1300 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14, flexWrap: 'wrap', gap: 10 }}>
        <div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
            <span style={{ fontSize: 22, fontWeight: 800 }}>🌊 OI Ride-R</span>
            {/* next_week_active means the contract is ALREADY the later one;
                next_week_today means it is configured for today but the expiry
                has not been fetched yet. Distinguishing them matters — the
                second is a waiting state, not a live one. */}
            {state && state.next_week_active ? (
              <span style={{ fontSize: 9, fontWeight: 800, letterSpacing: 1, padding: '3px 8px', borderRadius: 6, background: 'rgba(56,189,248,0.14)', color: '#38bdf8', border: '1px solid rgba(56,189,248,0.45)' }}>
                NEXT WEEK {state.expiry_iso || ''}
              </span>
            ) : state && state.next_week_today ? (
              <span style={{ fontSize: 9, fontWeight: 800, letterSpacing: 1, padding: '3px 8px', borderRadius: 6, background: 'rgba(251,191,36,0.12)', color: '#fbbf24', border: '1px solid rgba(251,191,36,0.5)' }}>
                NEXT WEEK — awaiting expiry
              </span>
            ) : null}
            <span style={{ fontSize: 9, fontWeight: 800, letterSpacing: 1, color: '#38bdf8', background: 'rgba(56,189,248,0.1)', border: '1px solid rgba(56,189,248,0.4)', borderRadius: 6, padding: '3px 8px' }}>SIGNALS ONLY — NO ORDERS</span>
            <span style={{ fontSize: 9, fontWeight: 800, letterSpacing: 1, color: '#a78bfa', background: 'rgba(167,139,250,0.1)', border: '1px solid rgba(167,139,250,0.45)', borderRadius: 6, padding: '3px 8px' }}>DEBIT · buy ATM + sell wing</span>
            {state && state.is_expiry_day ? <span style={{ fontSize: 9, fontWeight: 800, color: '#fbbf24', background: 'rgba(251,191,36,0.1)', border: '1px solid rgba(251,191,36,0.45)', borderRadius: 6, padding: '3px 8px' }}>EXPIRY · hedge ATM±{cfg.hedge_offset_expiry || 1}</span> : null}
            {state && state.day_stopped ? <span style={{ fontSize: 9, fontWeight: 800, color: '#ef4444', background: 'rgba(239,68,68,0.1)', border: '1px solid rgba(239,68,68,0.45)', borderRadius: 6, padding: '3px 8px' }}>DAY STOPPED · {state.day_stopped}</span> : null}
          </div>
          <div style={{ fontSize: 10, color: '#6b7a8d', marginTop: 3 }}>
            NIFTY · {cfg.paper_lots || 1}L · Entry {cfg.entry_time || '09:17'} · flips on reverse ≥{cfg.threshold_pct || 10}% · exit {cfg.exit_time || '15:00'}
          </div>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <span style={{ fontSize: 10, fontWeight: 800, letterSpacing: 1, color: enabled ? '#22c55e' : '#6b7a8d' }}>
            {enabled ? '● ENABLED' : '○ DISABLED'}
          </span>
          <button onClick={function () { postCfg({ enabled: !enabled }); }}
            style={{ fontSize: 11, fontWeight: 800, cursor: 'pointer', fontFamily: 'inherit', borderRadius: 8, padding: '7px 18px',
                     background: enabled ? 'rgba(239,68,68,0.12)' : 'rgba(34,197,94,0.12)',
                     color: enabled ? '#ef4444' : '#22c55e',
                     border: '1px solid ' + (enabled ? 'rgba(239,68,68,0.5)' : 'rgba(34,197,94,0.5)') }}>
            {enabled ? 'Disable' : 'Enable'}
          </button>
          <button onClick={openCfg}
            style={{ fontSize: 11, fontWeight: 800, cursor: 'pointer', background: 'transparent', color: '#8b98a9', border: '1px solid #1f2937', borderRadius: 8, padding: '7px 14px', fontFamily: 'inherit' }}>⚙</button>
        </div>
      </div>

      {err ? <div style={{ ...cardBase, borderColor: 'rgba(251,191,36,0.45)', color: '#fbbf24', fontSize: 11, marginBottom: 12 }}>OI Ride: {err}</div> : null}

      <div style={{ display: 'flex', gap: 12, marginBottom: 12, flexWrap: 'wrap' }}>
        <div style={{ flex: 1.2, minWidth: 320, ...cardBase }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
            <span style={{ fontSize: 10, fontWeight: 800, letterSpacing: 1, color: '#556677' }}>SIGNAL · ΔOI ATM±{cfg.strikes_band || 20} (day)</span>
            <span style={{ fontSize: 10, color: '#6b7a8d' }}>{sig.time || '--'}</span>
          </div>
          <div style={{ display: 'grid', gap: 6 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}><span style={{ fontSize: 10, color: '#22c55e', fontWeight: 800, width: 28 }}>ΔPE</span><div style={{ flex: 1 }}>{bar(sig.dpe || 0, '#22c55e')}</div></div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}><span style={{ fontSize: 10, color: '#ef4444', fontWeight: 800, width: 28 }}>ΔCE</span><div style={{ flex: 1 }}>{bar(sig.dce || 0, '#ef4444')}</div></div>
          </div>
          <div style={{ marginTop: 10, display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
            <span style={{ fontSize: 20, fontWeight: 800, color: vCol }}>{sig.verdict || '--'}</span>
            <span style={{ fontSize: 12, color: '#c4cfd8' }}>{sig.pct != null ? (sig.pct > 0 ? '+' : '') + sig.pct + '%' : ''} <span style={{ color: '#6b7a8d' }}>(±{cfg.threshold_pct || 10}%)</span></span>
            {pend.dir ? <span style={{ fontSize: 10, fontWeight: 800, color: '#fbbf24' }}>confirming {pend.dir} {pend.count}/{pend.need}</span> : null}
          </div>
        </div>

        <div style={{ flex: 1, minWidth: 300, ...cardBase }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
            <span style={{ fontSize: 10, fontWeight: 800, letterSpacing: 1, color: '#556677' }}>POSITION</span>
            {pos ? <span style={{ fontSize: 11, fontWeight: 800, color: (pos.unrealized || 0) >= 0 ? '#22c55e' : '#ef4444' }}>{fmtINR(pos.unrealized)}{pos.peak_pl ? <span style={{ color: '#6b7a8d', fontWeight: 400 }}> · peak {fmtINR(pos.peak_pl)}/L</span> : null}</span> : null}
          </div>
          {pos ? (
            <div style={{ fontSize: 11, lineHeight: 1.9 }}>
              <div style={{ fontWeight: 800, color: pos.dir === 'LONG' ? '#22c55e' : '#ef4444' }}>
                {pos.dir} · {pos.lots || 1}L · since {pos.opened} · net {pos.credit}
                {pos.protect_armed ? <span style={{ fontSize: 9, color: '#fbbf24', marginLeft: 8 }}>PROTECT ARMED</span> : null}
              </div>
              {(pos.legs || []).map(function (l, i) {
                return <div key={i} style={{ color: '#8b98a9' }}>
                  {l.kind === 'sell' ? 'SELL' : 'HEDGE'} {l.strike} {l.side} @ {l.entry} → {l.ltp}
                  <span style={{ float: 'right', fontWeight: 800, color: (l.pnl || 0) >= 0 ? '#22c55e' : '#ef4444' }}>{fmtINR(l.pnl)}</span>
                </div>;
              })}
            </div>
          ) : (
            <div style={{ fontSize: 10, color: '#6b7a8d', padding: '14px 0', textAlign: 'center' }}>
              {state && state.day_stopped ? 'Day stopped (' + state.day_stopped + ') — flat until tomorrow. Reset paper to resume.' : 'Flat. Enters on the next confirmed signal after ' + (cfg.entry_time || '09:17') + '.'}
            </div>
          )}
        </div>
      </div>

      <div style={{ display: 'flex', gap: 8, marginBottom: 12, flexWrap: 'wrap' }}>
        <StatBox label="DAY P&L" value={fmtINR(st.day_pnl)} color={(st.day_pnl || 0) >= 0 ? '#22c55e' : '#ef4444'} />
        <StatBox label="REALIZED" value={fmtINR(st.realized)} color={(st.realized || 0) >= 0 ? '#22c55e' : '#ef4444'} />
        <StatBox label="UNREALIZED" value={fmtINR(st.unrealized)} color={(st.unrealized || 0) >= 0 ? '#22c55e' : '#ef4444'} />
        <StatBox label={(state && state.structure) === 'debit' ? 'SELL WING P&L' : 'SELL ATM P&L'} value={fmtINR(sellPnl)} color={(sellPnl || 0) >= 0 ? '#22c55e' : '#ef4444'} />
        <StatBox label="TRADES" value={st.trades != null ? st.trades : '--'} />
        <StatBox label="FLIPS" value={st.flips != null ? st.flips : '--'} color="#38bdf8" />
        <StatBox label={'vs CREDIT'} value={sibPnl != null ? fmtINR(sibPnl) : '--'} color={(sibPnl || 0) >= 0 ? '#a78bfa' : '#ef4444'} />
      </div>

      <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', alignItems: 'flex-start' }}>
        <div style={{ flex: 1.2, minWidth: 340, ...cardBase }}>
          <div style={{ fontSize: 10, fontWeight: 800, letterSpacing: 1, color: '#556677', marginBottom: 10 }}>TRADES TODAY</div>
          {trades.length ? trades.map(function (t, i) {
            return (
              <div key={i} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 8, padding: '7px 0', borderBottom: '1px solid #131a2a', fontSize: 11, flexWrap: 'wrap' }}>
                <span style={{ fontWeight: 800, color: t.dir === 'LONG' ? '#22c55e' : '#ef4444' }}>{t.dir}</span>
                <span style={{ color: '#8b98a9' }}>{t.opened} → {t.closed}</span>
                <span style={{ color: '#6b7a8d' }}>ATM {t.atm}</span>
                <span style={{ fontSize: 9, fontWeight: 800, color: '#8b98a9' }}>{t.reason}</span>
                <span style={{ fontWeight: 800, color: (t.pnl || 0) >= 0 ? '#22c55e' : '#ef4444' }}>{fmtINR(t.pnl)}</span>
              </div>
            );
          }) : <div style={{ fontSize: 10, color: '#6b7a8d', padding: '14px 0', textAlign: 'center' }}>No closed trades yet today.</div>}
        </div>
        <div style={{ flex: 1, minWidth: 300, ...cardBase }}>
          <div style={{ fontSize: 10, fontWeight: 800, letterSpacing: 1, color: '#556677', marginBottom: 10 }}>EVENTS</div>
          <div style={{ maxHeight: 300, overflowY: 'auto' }}>
            {events.length ? events.slice().reverse().map(function (ev, i) {
              return <div key={i} style={{ fontSize: 10, color: '#8b98a9', padding: '3px 0', borderBottom: '1px solid #0d1524' }}>
                <span style={{ color: '#556677' }}>{ev.time}</span> {ev.text}
              </div>;
            }) : <div style={{ fontSize: 10, color: '#6b7a8d', textAlign: 'center', padding: '14px 0' }}>Quiet.</div>}
          </div>
        </div>
      </div>

      {showCfg ? (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(3,6,12,0.75)', zIndex: 60, display: 'flex', alignItems: 'flex-start', justifyContent: 'center', overflowY: 'auto', padding: '40px 16px' }}
          onClick={function (e) { if (e.target === e.currentTarget) setShowCfg(false); }}>
          <div style={{ background: '#0b1220', border: '1px solid #26334a', borderRadius: 14, padding: '22px 26px', width: '100%', maxWidth: 560 }}>
            <div style={{ fontSize: 18, fontWeight: 800, marginBottom: 18 }}>OI Ride Settings</div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 }}>
              <Field label="Entry Time" value={draft.entry_time} onChange={D('entry_time')} />
              <Field label="Exit Time" value={draft.exit_time} onChange={D('exit_time')} />
              <Field label="Lots" type="number" value={draft.paper_lots} onChange={D('paper_lots')} />
              <Field label="Check Interval (s)" type="number" value={draft.check_interval_sec} onChange={D('check_interval_sec')} />
              <Field label="Signal Threshold %" type="number" value={draft.threshold_pct} onChange={D('threshold_pct')} />
              <Field label="Confirm Checks" value={draft.confirm_checks} onChange={D('confirm_checks')}
                options={[[1, '1 · immediate'], [2, '2 · +30s confirm'], [3, '3 · +60s confirm'], [4, '4 · +90s confirm']]} />
              <Field label="Signal Strikes Band" value={draft.strikes_band} onChange={D('strikes_band')}
                options={[[10, 'ATM ±10'], [20, 'ATM ±20'], [0, 'All strikes']]} />
              <Field label="Fill Haircut % / leg" type="number" value={draft.spread_haircut_pct} onChange={D('spread_haircut_pct')} />
            </div>
            <div style={{ fontSize: 11, fontWeight: 800, letterSpacing: 1, color: '#556677', margin: '20px 0 10px' }}>NEXT WEEK EXPIRY <span style={{ color: '#6b7a8d', fontWeight: 400 }}>(ticked days trade the following week's contract)</span></div>
            <div style={{ fontSize: 10, color: '#6b7a8d', marginBottom: 8 }}>
              On a ticked day the position is taken on next week's expiry, and the hedge uses the NORMAL
              distance even if today is the front expiry — next week's contract is not expiring.
            </div>
            <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginBottom: 4 }}>
              {[['monday','Mon'],['tuesday','Tue'],['wednesday','Wed'],['thursday','Thu'],['friday','Fri']].map(function (d) {
                var key = d[0];
                var on = !!(draft.next_week_days || {})[key];
                return (
                  <label key={key} style={{
                    display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer',
                    background: on ? 'rgba(56,189,248,0.10)' : '#0d1524',
                    border: '1px solid ' + (on ? 'rgba(56,189,248,0.45)' : '#26334a'),
                    borderRadius: 6, padding: '6px 11px',
                  }}>
                    <input type="checkbox" checked={on}
                      onChange={function (e) {
                        var w = Object.assign({}, draft.next_week_days || {});
                        w[key] = e.target.checked;
                        D('next_week_days')(w);
                      }} />
                    <span style={{ fontSize: 11, fontWeight: 800, color: on ? '#38bdf8' : '#556677' }}>{d[1]}</span>
                  </label>
                );
              })}
            </div>

            <div style={{ fontSize: 11, fontWeight: 800, letterSpacing: 1, color: '#556677', margin: '20px 0 10px' }}>HEDGE</div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 }}>
              <Field label="Hedge Distance (normal)" value={draft.hedge_offset_normal} onChange={D('hedge_offset_normal')}
                options={[[1, 'ATM ±1 strike (50 pts)'], [2, 'ATM ±2 strikes (100 pts)'], [3, 'ATM ±3 strikes (150 pts)']]} />
              <Field label="Hedge Distance (expiry day)" value={draft.hedge_offset_expiry} onChange={D('hedge_offset_expiry')}
                options={[[1, 'ATM ±1 strike (50 pts)'], [2, 'ATM ±2 strikes (100 pts)']]} />
            </div>
            <div style={{ fontSize: 11, fontWeight: 800, letterSpacing: 1, color: '#556677', margin: '20px 0 10px' }}>PROFIT MANAGEMENT <span style={{ color: '#6b7a8d', fontWeight: 400 }}>(₹ per lot · any trigger exits & stops the day)</span></div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 }}>
              <Field label="MTM SL ₹/lot" hint="(0=off)" type="number" value={draft.mtm_sl_per_lot} onChange={D('mtm_sl_per_lot')} />
              <Field label="Target ₹/lot" hint="(0=off)" type="number" value={draft.target_per_lot} onChange={D('target_per_lot')} />
              <Field label="Protect ₹/lot" hint="(0=off)" type="number" value={draft.protect_per_lot} onChange={D('protect_per_lot')} />
              <Field label="Protect Level ₹/lot" type="number" value={draft.protect_level_per_lot} onChange={D('protect_level_per_lot')} />
              <Field label="Trail Step ₹/lot" hint="(0=off)" type="number" value={draft.trail_step_per_lot} onChange={D('trail_step_per_lot')} />
            </div>
            <div style={{ display: 'flex', gap: 12, marginTop: 24 }}>
              <button onClick={function () { setShowCfg(false); }}
                style={{ flex: 1, fontSize: 13, fontWeight: 800, cursor: 'pointer', fontFamily: 'inherit', background: '#0d1524', color: '#c4cfd8', border: '1px solid #26334a', borderRadius: 10, padding: '12px 0' }}>Cancel</button>
              <button onClick={saveCfg}
                style={{ flex: 1, fontSize: 13, fontWeight: 800, cursor: 'pointer', fontFamily: 'inherit', background: 'rgba(34,197,94,0.15)', color: '#22c55e', border: '1px solid rgba(34,197,94,0.5)', borderRadius: 10, padding: '12px 0' }}>Save</button>
            </div>
            <div style={{ marginTop: 14, textAlign: 'center' }}>
              <button onClick={function () { fetch(API + '/oirider/reset-paper', { method: 'POST' }).then(function () { setShowCfg(false); setTimeout(fetchState, 400); }); }}
                style={{ fontSize: 10, fontWeight: 800, cursor: 'pointer', background: 'transparent', color: '#ef4444', border: '1px solid rgba(239,68,68,0.4)', borderRadius: 8, padding: '6px 16px', fontFamily: 'inherit' }}>Reset paper · clears day-stop</button>
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default OIRideR;
